module.exports = __webpack_public_path__ + "static/remoteicon-e1e337afdadb3f968ca4592db0a1d7b2.jpeg";